import axios, { AxiosError } from "axios"
import { LIST_PATH, CATEGORY_PATH } from "../../constants/paths"
import { requestInterceptorSuccessCredentials, requestInterceptorErrorSecurityCredentials, responseInterceptorSuccessCredentials, responseInterceptorErrorCredentials } from "interceptors"

const instance = axios.create({
  baseURL: process.env.REACT_APP_CONFIGURATION_API_SERVICE_DOMAIN,
})
instance.interceptors.request.use(
  requestInterceptorSuccessCredentials,
  requestInterceptorErrorSecurityCredentials
)

instance.interceptors.response.use(
  responseInterceptorSuccessCredentials,
  responseInterceptorErrorCredentials
)

export const getCategoriesService = async () => {
  try {
    const result = await instance.get(CATEGORY_PATH + LIST_PATH)
    return result.data
  } catch (error: any) {
    const e: AxiosError = error
    throw new Error(e.response?.data)
  }
}

export const createCategoryService = async (category: any) => {
  try {
    const result = await instance.post(CATEGORY_PATH, category)
    return result.data
  } catch (error: any) {
    const e: AxiosError = error
    throw new Error(e.response?.data)
  }
}

export const deleteCategoryService = async (id: any) => {
  try {
    const result = await instance.delete(CATEGORY_PATH + `/${id}`)
    return result.data
  } catch (error: any) {
    const e: AxiosError = error
    throw new Error(e.response?.data)
  }
}

export const editCategoryService = async (id: number, category: any) => {
  try {
    const result = await instance.put(CATEGORY_PATH + `/${id}`, category)
    return result.data
  } catch (error: any) {
    const e: AxiosError = error
    throw new Error(e.response?.data)
  }
}
